<template>
    <div>

        <!-- Modal Validade Arquivo -->
        <div class="modal fade" :id="modal_name + 'validModal'" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="arquivo">
                    <div class="modal-header">
                        <h5 class="modal-title">Validade do Arquivo</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                            {{ arquivo.arquivo.st_titulo }}
                            <span class="badge badge-info ml-2">#{{ arquivo.id_arquivo }}</span>
                        </div>

                        <az-input   
                            label="Data de Validade"
                            type="date"
                            :validate="validate"
                            v-model="arquivo.dt_validade" />

                        <az-input   
                            class="mt-2"
                            sizing="sm"
                            label="Revogado"
                            type="checkbox-group"
                            :validate="validate"
                            v-model="arquivo.fl_revogado" />

                        <az-input   
                            v-if="arquivo.fl_revogado"
                            label="Observações"
                            type="textarea"
                            :validate="validate"
                            v-model="arquivo.st_info_revogado" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() {
        return { 
            arquivo: null,
            validate: false, 
        }
    },

    props: ['modal_name'], 

    components: { 
        AzInput,
        AzSubmit, 
    },

    methods: { 
        fechar() { 
            this.arquivo = null;
            $(`#${this.modal_name}validModal`).modal('hide');
        },

        abrir(arquivo) { 
            this.arquivo = _.cloneDeep(arquivo);

            $(`#${this.modal_name}validModal`).modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'arquivo_links',
                func: 'store',
                dados: this.arquivo,
                modal: `${this.modal_name}validModal`,
                callback: () => { 
                    this.$emit('refresh');
                },
            });
        }
   
    }
}
</script>
